import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Oustationtaxiservicepune() {



const cardData = {
  keyword: "Outstation Taxi Service Pune",
  heading: "Lotus Cab: Outstation Taxi Service Pune",

  headingDescription:
    "Lotus Cab provides reliable Outstation Taxi Service Pune for safe and comfortable long-distance travel. Whether you are planning a business trip, pilgrimage, weekend getaway, or family vacation, we offer well-maintained AC sedans and spacious SUVs. Our professional drivers are experienced in highway and interstate routes, ensuring smooth travel across Maharashtra and neighboring states. Transparent per kilometer pricing with no hidden charges makes budgeting easy. Flexible one-way and round-trip booking options are available. With 24/7 customer support and punctual pickup anywhere in Pune, we ensure stress-free outstation journeys.",

  top: "Top Places to Visit from Pune with Lotus Cab",

  topPlaces: [
    {
      title: "Mumbai",
      description:
        "Mumbai is one of the most popular outstation destinations from Pune. The city offers iconic landmarks like Gateway of India and Marine Drive. Business travelers frequently commute for corporate meetings. The Mumbai-Pune Expressway ensures smooth highway travel. One-way and round-trip cab services are available. It remains a high-demand route for outstation travel."
    },
    {
      title: "Nashik",
      description:
        "Nashik is famous for its temples and vineyards. It is home to the sacred Trimbakeshwar Temple. Tourists also visit Sula Vineyards for wine tourism. The road journey from Pune is comfortable and scenic. Outstation cab service makes weekend travel convenient. It is ideal for pilgrimage and leisure trips."
    },
    {
      title: "Shirdi",
      description:
        "Shirdi is a major pilgrimage center dedicated to Sai Baba. Devotees travel frequently for temple darshan. Early morning departures are common for same-day return trips. Safe and punctual driving ensures timely temple arrival. SUV options are preferred for family groups. It remains one of the most booked outstation routes."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a popular hill station near Pune. It is known for strawberry farms and scenic viewpoints. Families enjoy weekend relaxation here. The winding ghat roads require skilled drivers. Comfortable sedans and SUVs ensure smooth travel. It is perfect for short outstation vacations."
    },
    {
      title: "Bangalore",
      description:
        "Bangalore is a major IT and business hub. Corporate travelers frequently book long-distance cabs to the city. The interstate journey requires experienced highway drivers. Round-trip and one-way options are available. Comfortable vehicles reduce long travel fatigue. It is ideal for business and relocation travel."
    },
    {
      title: "Goa",
      description:
        "Goa attracts tourists for beaches and nightlife. Long-distance outstation cab service ensures relaxed travel. Multi-day bookings are common for Goa trips. SUV vehicles are recommended for group travel. Safe highway driving is ensured. It remains a top leisure destination."
    },
    {
      title: "Kolhapur",
      description:
        "Kolhapur is known for Mahalaxmi Temple and cultural heritage. Pilgrimage travelers frequently book this route. Comfortable travel ensures relaxed temple visits. One-way and return packages are available. Professional drivers handle highway routes safely. Affordable pricing makes travel easy."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a quick weekend getaway from Pune. Famous for waterfalls and Tiger Point. Ideal for family and couple trips. Smooth expressway connectivity makes travel convenient. Affordable outstation cabs are available. Flexible booking ensures easy planning."
    }
  ],

  services: [
    {
      name: "Pune Outstation Cab Service",
      description:
        "Our Pune outstation cab service offers reliable long-distance travel options. Sedans and SUVs are available for different group sizes. Drivers are trained for interstate highway driving. Transparent per kilometer billing is followed. Flexible pickup timing from anywhere in Pune. Ideal for business and leisure travel."
    },
    {
      name: "Pune One Way Outstation Taxi",
      description:
        "One-way outstation taxi allows customers to pay only for drop distance. Ideal for airport transfers and relocation travel. No return fare is charged unnecessarily. Transparent pricing is maintained. Comfortable AC vehicles are provided. Affordable option for single-direction travel."
    },
    {
      name: "Pune Round Trip Outstation Cab",
      description:
        "Round-trip cab service allows flexible return scheduling. Suitable for multi-day tours and family visits. Drivers coordinate pickup and return timing efficiently. Vehicles remain clean and maintained. Transparent billing ensures trust. Comfortable long-distance travel guaranteed."
    },
    {
      name: "Affordable Outstation Taxi Pune",
      description:
        "Affordable outstation taxi service offers budget-friendly pricing. No hidden charges are applied. Sedan options provide economical travel. Ideal for regular travelers. Transparent rate structure ensures clarity. Quality service at reasonable cost."
    },
    {
      name: "Luxury Outstation Cab Pune",
      description:
        "Luxury outstation cab options provide premium comfort. Plush seating enhances long-distance travel. Suitable for executive and VIP clients. Vehicles are maintained to high standards. Professional chauffeurs ensure punctuality. Stress-free premium experience guaranteed."
    },
    {
      name: "24/7 Outstation Cab Pune",
      description:
        "24/7 outstation cab booking is available round the clock. Early morning and late-night departures supported. Immediate booking confirmation provided. Reliable drivers ensure safe travel. Flexible travel planning possible. Convenient service anytime."
    },
    {
      name: "Family Trip Outstation Cab Pune",
      description:
        "Family trip cabs are spacious and comfortable. SUVs provide extra luggage space. Safe driving ensures smooth travel for senior citizens. Ideal for temple tours and vacations. Flexible itinerary planning available. Comfortable long-distance journey assured."
    },
    {
      name: "Corporate Outstation Taxi Pune",
      description:
        "Corporate taxi service supports business travel needs. Monthly billing options are available. Executive-class vehicles provided. Punctual pickups ensure professional scheduling. Transparent fare structure maintained. Reliable interstate travel ensured."
    }
  ],

  tableData: [
    ["Outstation Taxi Service Pune", "Pune Outstation Cab Service"],
    ["Pune One Way Outstation Taxi", "Pune Round Trip Outstation Cab"],
    ["Affordable Outstation Taxi Pune", "Luxury Outstation Cab Pune"],
    ["24/7 Outstation Cab Pune", "Pune to Mumbai Outstation Taxi"],
    ["Pune to Nashik Outstation Cab", "Pune to Shirdi Outstation Taxi"],
    ["Pune to Bangalore Outstation Cab", "Family Trip Outstation Cab Pune"],
    ["Corporate Outstation Taxi Pune", "Cheap Outstation Taxi Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription:
        "Our drivers are trained for interstate highway travel. They follow strict safety standards. Long-distance fatigue management is ensured. Route familiarity reduces delays. Smooth and secure driving is prioritized."
    },
    {
      WhyChooseheading: "Transparent Fare Policy",
      WhyChoosedescription:
        "We provide clear per km fare breakdown. No hidden charges are added later. Toll and allowance details are explained. Transparent billing builds trust. Customers travel confidently."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV vehicles are available. Customers choose according to group size. Clean and maintained fleet ensured. Comfortable seating for long journeys. Flexible vehicle selection provided."
    },
    {
      WhyChooseheading: "Flexible Booking Options",
      WhyChoosedescription:
        "One-way and round-trip bookings available. Departure timing adjustable. Multi-day travel supported. Easy booking confirmation provided. Travel planning made simple."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Support team available round the clock. Quick response for queries. Immediate booking assistance provided. Emergency travel support available. Reliable communication maintained."
    },
    {
      WhyChooseheading: "Family-Friendly Travel",
      WhyChoosedescription:
        "Spacious SUVs ideal for family trips. Safe driving ensured for children and seniors. Comfortable long journeys supported. Flexible sightseeing coordination available. Peaceful travel experience guaranteed."
    },
    {
      WhyChooseheading: "Corporate Travel Expertise",
      WhyChoosedescription:
        "Professional service for business travelers. Executive vehicles available. Punctual scheduling maintained. Monthly billing options provided. Reliable long-distance corporate transport."
    },
    {
      WhyChooseheading: "Affordable Pricing Structure",
      WhyChoosedescription:
        "Competitive pricing across all routes. Budget-friendly options available. Clear fare estimation before booking. No surprise billing. Cost-effective travel guaranteed."
    }
  ]
};

const faqData = [
  { question: "Do you provide one-way outstation taxi from Pune?", answer: "Yes, one-way outstation taxi service is available. Customers pay only for single-side distance. Transparent pricing is maintained. Suitable for airport and city transfers." },
  { question: "How is outstation cab fare calculated?", answer: "Fare is calculated per kilometer with minimum running criteria. Toll and driver allowance are explained clearly. Transparent billing policy followed." },
  { question: "Are SUVs available for long-distance travel?", answer: "Yes, SUV options are available for family and group travel. Extra luggage space provided. Comfortable seating ensured." },
  { question: "Is night outstation service available?", answer: "Yes, 24/7 outstation cab service is available. Safe night driving ensured. Advance booking recommended." },
  { question: "Can I book a round-trip cab?", answer: "Yes, round-trip bookings are available. Flexible return timing supported. Multi-day trips possible." },
  { question: "Do you provide corporate outstation travel?", answer: "Yes, corporate travel packages available. Executive vehicles provided. Monthly billing supported." },
  { question: "Is pricing transparent?", answer: "Yes, complete fare estimation shared before confirmation. No hidden charges applied." },
  { question: "Are toll charges included?", answer: "Toll charges are explained clearly before booking. Transparent billing policy followed." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak travel seasons. Immediate confirmation provided." },
  { question: "How can I book outstation cab from Pune?", answer: "Booking can be done via call or WhatsApp. Instant confirmation provided. 24/7 support available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback: "Booked Pune to Mumbai outstation taxi with Lotus Cab. Driver was punctual and professional. Fare structure was transparent with no hidden charges. Comfortable vehicle made long journey smooth. Highly recommended for outstation travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kulkarni",
    feedback: "We used Lotus Cab for family trip to Nashik. The SUV was spacious and clean. Pricing was reasonable and clearly explained. Driver handled highway safely. Very satisfied with service.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rohit Sharma",
    feedback: "Corporate trip to Bangalore was managed professionally. On-time pickup and comfortable sedan provided. Transparent billing impressed us. Reliable service for business travel.",
    rating: 5
  }
];


















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service Pune",
  "image": "https://lotuscab.com/assets/images/outstation-taxi-service-pune.jpg", 
  "description": "Lotus Cab provides reliable outstation taxi service in Pune with affordable one way and round trip options. Travel comfortably from Pune to Mumbai, Nashik, Shirdi, Bangalore and other cities with sedan, SUV, and luxury cabs for family, corporate, and leisure trips.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/outstation-taxi-service-pune"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Outstation Taxi Service Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book outstation taxi service in Pune with Lotus Cab. Affordable one way & round trip cabs to Mumbai, Nashik, Shirdi, Bangalore & more. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Outstation Taxi Service Pune, Pune Outstation Cab Service, Pune One Way Outstation Taxi, Pune Round Trip Outstation Cab, Affordable Outstation Taxi Pune, Luxury Outstation Cab Pune, 24/7 Outstation Cab Pune, Pune to Mumbai Outstation Taxi, Pune to Nashik Outstation Cab, Pune to Shirdi Outstation Taxi, Pune to Bangalore Outstation Cab, Family Trip Outstation Cab Pune, Corporate Outstation Taxi Pune, Cheap Outstation Taxi Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Oustationtaxiservicepune;